const initState = () => ({
  available: 3450,
  reports: [
    {
      num: "9023",
      dadd: "2020-10-06",
      name: "Тест!",
      deal: "3099",
      sum: 2290
    }
  ],
  page: 1,
  pageSize: 5,
  total: null
});

export default {
  namespaced: true,
  state: initState,
  mutations: {
    setPage: (state, value) => (state.page = value),
    setPageSize: (state, value) => (state.pageSize = value),
    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    }
  }
};
